import React, {useEffect, useState} from 'react';
import { Modal } from 'react-bootstrap';
import { Global } from '../Variables/Global';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import Util from '../../Classes/Utils';
import { Swiper, SwiperSlide } from "swiper/react"; import "swiper/css";
import { FreeMode, Navigation, Thumbs } from "swiper";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { AddItemToCart } from '../Data';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ProductModal = (props) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [isLogged, setIsLogged] = useState(false);
    const navigate = useNavigate();

    const AddToCart = (ProductId, ProductVariationId) => {
        if (isLogged) {
            const getItem = (localStorage.getItem('Cart') !== null);
            if (getItem) {
                var CartId = Util.decrypt(localStorage?.getItem("Cart"));
                AddItemToCart(CartId, ProductId, ProductVariationId, quantity).then((response) => {
                    if (response.ok) {
                        toast.success("Item added to cart");
                        return response.json();
                    } else {
                        return Response.text().then((text) => {
                            throw new Error(text);
                        });
                    }
                }).catch((error) => {
                    toast.error("Could Not Add");
                })

            }
        } else {
            navigate('/Authentication');
        }
    }

    useEffect(() => {
        if (localStorage.getItem("PMToken") === null) {
            setIsLogged(false);
        } else {
            setIsLogged(true);
        }
    },[])

    return (
        <>
            <Modal
                show={props.showModal}
                fullscreen={true}
                onHide={() => props.setShowModal(false)}
            >
                <Modal.Header closeButton>
                    { props.productDetails.ProductName}
                    
                </Modal.Header>
                <Modal.Body >
                <div className="single-product-content ">
                            <div className="container">
                                <div className="single-product-content-container mb-3">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-12 col-xs-12">

                                            <Swiper
                                                spaceBetween={10}
                                                navigation={false}
                                                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                                modules={[FreeMode, Navigation, Thumbs]}
                                                className="mySwiper2"
                                                allowTouchMove={false}
                                            >

                                                <>
                                                
                                                    {
                                                        props.productDetails.DefaultVariation.Image1 != "" && (
                                                            <SwiperSlide>
                                                                <img id="image1" src={Global.PHOTO_URL + props.productDetails.DefaultVariation.Image1} alt={props.productDetails.ProductName} style={{width: '600px',height:"500px"}} />
                                                            </SwiperSlide>
                                                        )}
                                                    {
                                                        props.productDetails.DefaultVariation.Image2 != "" && (
                                                            <SwiperSlide>
                                                                <img id="image2" src={Global.PHOTO_URL + props.productDetails.DefaultVariation.Image2} alt={props.productDetails.ProductName} style={{width: '600px',height:"500px"}} />
                                                            </SwiperSlide>
                                                        )}
                                                   
                                                </>

                                            </Swiper>
                                            <Swiper
                                                onSwiper={props.setThumbsSwiper}
                                                spaceBetween={10}
                                                slidesPerView={4}
                                                freeMode={true}
                                                watchSlidesProgress={true}
                                                modules={[FreeMode, Navigation, Thumbs]}
                                                className="mySwiper mt-3"
                                            >

                                             
                                                {
                                                    props.productDetails.Image1 != "" && (
                                                        <SwiperSlide>
                                                            <img id="image11" src={Global.PHOTO_URL + props.productDetails.DefaultVariation.Image1} style={{width: '100px',height:"100px"}} alt={props.productDetails.ProductName} />
                                                        </SwiperSlide>
                                                    )
                                                }
                                                {
                                                    props.productDetails.Image2 != "" && (
                                                        <SwiperSlide>
                                                            <img id="image21" src={Global.PHOTO_URL + props.productDetails.DefaultVariation.Image2} style={{width: '100px',height:"100px"}}  alt={props.productDetails.ProductName} />
                                                        </SwiperSlide>
                                                    )
                                                }
                                                


                                            </Swiper>

                                        </div>
                                        <div className="col-lg-7 col-md-12 col-xs-12">
                                            <div className="product-feature-details">
                                                <h2 className="product-title mb-2">{props.productDetails.ProductName}</h2>


                                                <h2 className="product-price mb-2">
                                                    {
                                                        props.productDetails.DefaultVariation.SalePrice === 0 ? (
                                                            <span className="discounted-price">{props.productDetails.DefaultVariation.RegularPrice}</span>

                                                        ) : (
                                                            <span className="main-price"> {props.productDetails.DefaultVariation.SalePrice}</span>

                                                        )
                                                    }
                                                </h2>

                                                <p className="product-description mb-2" dangerouslySetInnerHTML={{ __html: props.productDetails.Description }}></p>


                                                <div className="cart-buttons mb-2">
                                                    <div className="pro-qty mr-2 mb-xs-2">
                                                        <input type="text" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                                                    </div>
                                                    <div className="add-to-cart-btn" style={{ marginLeft: '10px' }}>
                                                        <a onClick={() => AddToCart(props.productDetails.ProductId, props.productDetails.DefaultVariation.ProductVariationId)}><AiOutlineShoppingCart className='mb-1' />Add to Cart</a>
                                                    </div>
                                                </div>

                                                {
                                                    props.WishListItems.find(obj => obj.ProductId === props.productDetails.ProductId) ? (
                                                        <div className="single-product-action-btn mb-2">
                                                            <a className='RemUnderline' data-tooltip="Remove From wishlist" onClick={() => props.HandleRemoveFromWishList(props.productDetails.ProductId)}> <span className="icon_heart_alt"></span> Remove From
                                                                wishlist</a>
                                                        </div>

                                                    ) : (
                                                        <div className="single-product-action-btn mb-2">
                                                            <a className='RemUnderline' data-tooltip="Add to wishlist" onClick={() => props.HandleAddToWishList(props.productDetails.ProductId, props.productDetails.DefaultVariation.ProductVariationId)}> <span className="icon_heart_alt"></span> Add to
                                                                wishlist</a>
                                                        </div>
                                                    )
                                                }




                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>

                       


                       
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ProductModal